import { Checkbox } from "./ui/checkbox";
import { Badge } from "./ui/badge";

const day = (iso) => (iso ? new Date(iso).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }) : "—");

function Reasons({ reasons }) {
  return (
    <span className="flex flex-wrap gap-1">
      {reasons.map((r) => <span key={r} className="text-[9px] px-1.5 py-0.5 rounded bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-300">{r}</span>)}
    </span>
  );
}

export function TestDataTenantRow({ t, checked, onToggle }) {
  return (
    <label className={`flex items-start gap-3 rounded-md border px-3 py-2 cursor-pointer ${checked ? "border-red-300 bg-red-50/40 dark:bg-red-950/10" : "border-border"}`} data-testid={`test-data-tenant-${t.slug}`}>
      <Checkbox checked={checked} onCheckedChange={onToggle} className="mt-0.5" data-testid={`test-data-tenant-check-${t.slug}`} />
      <span className="flex-1 min-w-0">
        <span className="flex items-center gap-2 flex-wrap">
          <span className="font-medium text-sm">{t.name}</span>
          <span className="text-xs text-muted-foreground font-mono">{t.slug}</span>
          {t.is_sandbox && <Badge className="text-[9px] bg-purple-100 text-purple-700">Demo sandbox</Badge>}
          {t.paying && <Badge className="text-[9px] bg-amber-100 text-amber-800">Card subscription — will be cancelled</Badge>}
        </span>
        <span className="block text-xs text-muted-foreground mt-0.5">
          {t.users} user{t.users === 1 ? "" : "s"} · {t.jobs} job{t.jobs === 1 ? "" : "s"} · {t.clients} client{t.clients === 1 ? "" : "s"} · created {day(t.created_at)}{t.owner_email ? ` · owner ${t.owner_email}` : ""}
        </span>
        <span className="block mt-1"><Reasons reasons={t.reasons} /></span>
      </span>
    </label>
  );
}

export function TestDataUserRow({ u, checked, onToggle }) {
  return (
    <label className={`flex items-start gap-3 rounded-md border px-3 py-2 cursor-pointer ${checked ? "border-red-300 bg-red-50/40 dark:bg-red-950/10" : "border-border"}`} data-testid={`test-data-user-${u.email}`}>
      <Checkbox checked={checked} onCheckedChange={onToggle} className="mt-0.5" data-testid={`test-data-user-check-${u.email}`} />
      <span className="flex-1 min-w-0">
        <span className="flex items-center gap-2 flex-wrap">
          <span className="font-medium text-sm break-all">{u.email}</span>
          <span className="text-xs text-muted-foreground">{u.role?.replace(/_/g, " ")} · {u.tenant_name}</span>
          {u.is_platform_admin && <Badge className="text-[9px] bg-red-100 text-red-700">Platform admin — receives platform e-mails</Badge>}
        </span>
        <span className="block text-xs text-muted-foreground mt-0.5">{u.name || "—"} · created {day(u.created_at)} · last active {day(u.last_active_at)}</span>
        <span className="block mt-1"><Reasons reasons={u.reasons} /></span>
      </span>
    </label>
  );
}
